import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { ReelEngineEvent } from "@nolimitcity/slot-game/bin/core/engines/reel/event/ReelEngineEvent";
import { TimelineMax, Power3, TweenLite } from "gsap";
import { ReelState, ReelEngineController } from "@nolimitcity/slot-game/bin/core/engines/reel/ReelEngineController";
import { TimeCheckPoints } from "@nolimitcity/slot-game/bin/core/utils/TimeCheckPoints";
import { GameSetting } from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { SanParsedGameData } from "../../server/data/SanParsedGameData";
import { SanEngineManager } from "../../engine/SanEngineManager";
import { RevealerManager } from "../independent/revealer/RevealerManager";
import { Logger } from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { ReelSymbolName } from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import { SanEngineController } from "../../engine/SanEngineController";
import { SanSpriteSymbol, SanSymState } from "../../engine/Symbol/SanSpriteSymbol";
import { ReelAnimationManager } from "../independent/reelAnimator/ReelAnimationManager";
import { SoundManager } from "../../resource/sound/SoundManager";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { ScatterRevealPresentation } from "../features/scatter/ScatterRevealPresentation";
import { StateHandler } from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import { SanJumpData } from "../../server/data/ISanServerData";
import { JumpingWildController } from "../independent/jumpingWild/JumpingWildController";
import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { SanBackground } from "../background/SanBackground";
import { ArrayHelper } from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import { PostCounter } from "../independent/poster/PostCounter";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { AnimationEffects } from "../../effects/AnimationEffects";
import { JumpingWildCollector } from "../independent/collector/JumpingWildCollector";
import { SoundConfig } from "../../SoundConfig";
import { ReavealerState, Revealer } from "../independent/revealer/Revealer";
import { SplashViewJWWon } from "../independent/splashScreen/views/SplashViewJWWon";
import { SanParsedInitData } from "../../server/data/SanParsedInitData";
import { XWaysCounter } from "../independent/countup/XWaysCounter";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";

class StopFlowState extends StateHandler {

    public static readonly NORMAL: string = "normal";
    public static readonly BONUS_START: string = "bonus_start";
    public static readonly BONUS_JUMP: string = "bonus_jump";
    public static readonly BONUS_BARS: string = "bonus_bars";
    public static readonly BONUS_STOP: string = "bonus_stop";
}

export class ReelStopPresentation extends Presentation {

    private gameData: SanParsedGameData | undefined;
    private longestWin: number = 0;

    private nearWinLength: number = 0;
    private nearWinPos: number[][] = [];
    private possibleWinSymbols: string[][] = [];

    private startDarkAttention: number = -1;

    private playFsAnimations: boolean = false;
    private firstFs: boolean = false;
    private nextIsFS: boolean = false;
    private debugLogs: boolean = false;

    private stopFlow: StopFlowState = new StopFlowState(StopFlowState.NORMAL);
    private fsTimeline: TimelineMax;
    private wildTimeline: TimelineMax;

    private jumpData: SanJumpData[];

    private ifrestore:boolean = false;
    private stupidBuyFlag:boolean = false;

    private haveSkyDarkenned:boolean = false;

    private bigWinLvl:boolean = false;
    // private bigWinLvl_indx:number = 0;
    private bigWinLandsound:boolean = false;


    public addEventListeners() {
        EventHandler.addEventListener(this, ReelEngineEvent.REEL_STOP_COMPLETED, (event: GameEvent) => this.playStopAnimation(event.params[0]));
        EventHandler.addEventListener(this, ReelEngineEvent.REEL_STOP_SPIN_BOUNCE_STARTED, (event: GameEvent) => this.playBounceAnimation(event.params[0]));
        EventHandler.addEventListener(this, "FIRST_FS", (event: GameEvent) => this.playBounceAnimation(event.params[0]));
    }

    public isActive(): boolean {
        return (SanEngineManager.isPlaying) && super.isActive();
    }

    setParsedInitData(data:SanParsedInitData){
        this.ifrestore = data.isRestoreState;
    }

    public setParsedGamedData(data: SanParsedGameData): void {
        if (this.gameData) return;
        this.gameData = data;

        

        this.wildTimeline = Helper.timeLineKiller(this.wildTimeline, new TimelineMax());

        this.stupidBuyFlag = this.gameData.mode === GameMode.NORMAL && this.gameData!.wasFeatureBuy;

        this.debugLogs && console.log(data);

        this.nextIsFS = data.mode == GameMode.NORMAL && data.nextMode != GameMode.NORMAL;
        this.nearWinPos = data.nearWinMap;
        this.nearWinLength = this.nearWinPos.length;
        this.possibleWinSymbols = this.fetchHitSymbols();

        this.startDarkAttention = -1;
        this.firstFs = data.mode === "FREESPIN_SETUP";
        this.playFsAnimations = data.mode === GameMode.FREESPIN || this.firstFs;
        this.jumpData = this.gameData.sanJumpData;

        this.bigWinLandsound = false;
        this.bigWinLvl = this.isBigWinAntici();

        if (this.gameData.scatterAmount >= 2 && GameMode.NORMAL === this.gameData.mode) {
            let findStart: number = 0;
            for (let s: number = 0; s < data.scatterReelPositions.length; s++) {
                if (data.scatterReelPositions[s] >= 0) {
                    if (findStart == 1 && s != 4) {
                        this.startDarkAttention = s;
                        break;
                    }
                    findStart++;
                }
            }
        }

        RevealerManager.setResData(this.gameData.rawData.cellReelOne, this.gameData.rawData.cellReelTwo, data.rawData.mysterySymbolReveal, this.playFsAnimations);

        this.stopFlow.set(data.mode == GameMode.NORMAL ? StopFlowState.NORMAL : StopFlowState.BONUS_START);
        this.stopFlow.set(data.mode == GameMode.NORMAL ? StopFlowState.NORMAL : StopFlowState.BONUS_START, true);

        if(this.firstFs){
            this.stopFlow.set(StopFlowState.BONUS_STOP);
            this.stopFlow.set(StopFlowState.BONUS_STOP, true);
            this.startDarkAttention = -1;
        }

        if(data.mode === GameMode.FREESPIN){
            SanEngineManager.setFSSymbol(this.gameData.fsSym.sym,this.gameData.fsSym.val);
            RevealerManager.setFSSymbol(this.gameData.fsSym.sym,this.gameData.fsSym.val);
        }
    }

    private isBigWinAntici():boolean{
        const ratio:number = this.gameData!.singleWin/ this.gameData!.playedBetValue;
        const rand:number= Math.random();
        if(this.gameData!.mode === GameMode.NORMAL){
            return ratio > 15+(5*rand);
        }else if(this.gameData!.mode === GameMode.FREESPIN){
            const fsLvl:number = this.jumpData.length;
            if(fsLvl == 1){
                return ratio >  25+(10*rand);
            }
            if(fsLvl == 2){
                return ratio >  100+(30*rand);
            }
            if(fsLvl == 3){
                return ratio >  200+(50*rand);
            }
        }
        return false;
    }

    protected fetchHitSymbols(): string[][] {
        const arr: string[][] = [];
        for (let m: number = 0; m < this.nearWinPos.length; m++) {
            arr.push([]);
            for (let j: number = 0; j < this.nearWinPos[m].length; j++) {
                let symTargetName: string = this.gameData?.mode == GameMode.NORMAL ? this.gameData!.reels[m][this.nearWinPos[m][j] + 1] : this.gameData!.fsMergedreel[m][this.nearWinPos[m][j]];
                    
                if (arr[m].indexOf(symTargetName) == -1) {
                    arr[m].push(symTargetName);
                    if ([ReelSymbolName.WILD].indexOf(symTargetName) >= 0 && m != 0) {
                        arr[m] = arr[m].concat(arr[m - 1]);
                    }
                }
            }
            arr[m] = arr[m].filter((sym: string) => { return sym != ReelSymbolName.WILD && sym != ReelSymbolName.MYSTERY })
        }
        return arr;
    }

    public preStart(): void {

        if(this.ifrestore){
            this.ifrestore = false;
            SanEngineManager.setQuickStop(false);
        }

        if(this.stupidBuyFlag) SanEngineManager.setQuickStop(false);
        
        for (let i = 0; i < SanEngineManager.AllReels.length; i++) {  

            SanEngineManager.AllReels[i].createStop(this.firstFs);
            
            RevealerManager.getTopBar(i).setSpinMode(!this.firstFs);
            RevealerManager.getBotBar(i).setSpinMode(!this.firstFs);
        }
    }

    public getPresentation(): void {

        switch (this.stopFlow.state) {
            case StopFlowState.BONUS_START:
                this.BonusStart();
                break;
            case StopFlowState.BONUS_JUMP:
                this.BonusJump();
                break;
            case StopFlowState.BONUS_BARS:
                this.BonusBars();
                break;
            case StopFlowState.BONUS_STOP:
                this.BonusStop();
                break;
            default:
                if (SanEngineManager.findFirstReelWithState(ReelState.STEP) >= 0)
                    this.normalStop();
                else{
                    this.pTimeline.delay(0.1);
                    let isAnyActive:boolean = false;
                    for(let r = 0; r < SanEngineManager.AllReels.length;r++)
                        if(SanEngineManager.AllReels[r].isActive) {isAnyActive = true; break;}
                    if(!isAnyActive) this.PresentationState.set(PresentationState.INACTIVE);
                }
        }

        if(SanEngineManager.isQuickStop && !this.stopFlow.equal(StopFlowState.NORMAL)){
            if(!this.quickStopExpanding){
                this.pTimeline.timeScale(this.stupidBuyFlag ? 1 : 4);
                if(this.fsTimeline) this.fsTimeline.timeScale(this.stupidBuyFlag ? 1 : 4);
            }
        }else{
            if(this.fsTimeline) this.fsTimeline.timeScale(1);
        }
    }

    protected BonusStart(): void {
        this.debugLogs && console.log("BonusStart")

        if (this.stopFlow.equal(StopFlowState.BONUS_JUMP, true)) {
            this.pTimeline.delay((this.fsTimeline.duration() - this.fsTimeline.time()));
            return;
        }

        this.fsTimeline = Helper.timeLineKiller(this.fsTimeline,
            new TimelineMax({ onComplete: () => this.stopFlow.set(StopFlowState.BONUS_JUMP) })
        );

        PostCounter.instance.setAmount(PostCounter.instance.getAmount-1);
        
        const postDurr:number = this.fsTimeline.add(PostCounter.instance.play()).duration();
        this.fsTimeline.add(() => SlotGame.keypad.setZeroBetSpinCounter(PostCounter.instance.getAmount), 0.3);
        
        if(!JumpingWildCollector.instance.showing){
            for (let j: number = 0; j < JumpingWildController.instance.items.length; j++) {
                this.fsTimeline.fromTo(JumpingWildController.instance.items[j].cont,0.2,{alpha:1},{alpha:0.55}, 0);
                this.fsTimeline.to(JumpingWildController.instance.items[j].cont,0.3,{alpha:1}, postDurr-0.3);
            }
        }

        this.fsTimeline.add(() => SanEngineManager.RAll((r:number) => SanEngineManager.getReel(r).changeAlpha(0.75, 0.5)));

        this.stopFlow.set(StopFlowState.BONUS_JUMP, true);

        this.pTimeline.delay((this.fsTimeline.duration() - this.fsTimeline.time()));

    }

    private quickStopExpanding:boolean = false;
    protected BonusBars(): void {
        this.debugLogs && console.log("BonusBars");
        
        if (this.stopFlow.equal(StopFlowState.BONUS_STOP, true)) {
            this.pTimeline.to(this,(this.fsTimeline.duration() - this.fsTimeline.time()),{});

            if(SanEngineManager.isQuickStop)
                for(let r:number = 0; r <  SanEngineManager.AllReels.length; r++){
                    if(ScatterRevealPresentation.gotDoubleExpand(r)){
                        SanEngineManager.AllReels[r].doubleExpand = true;
                        ReelAnimationManager.getReelArea(r).stopPlusScatter();
                        this.quickStopExpanding = true;
                    } 
                }
            
            return;
        }

        this.fsTimeline = Helper.timeLineKiller(this.fsTimeline,
            new TimelineMax({ onComplete: () => this.stopFlow.set(StopFlowState.BONUS_STOP) })
        );

        this.quickStopExpanding = false;

        let delay: number = 0;
        let expandDurr: number = 0;
        let multUpgrade: number = 0;

        let animDurr: number = 0.5;
        let glowDelay:number = 0.1/(GameSetting.isFastSpin ? 1.25 : 1);

        switch(JumpingWildController.instance.items.length){
            case 1:
                glowDelay /= 2;
                // animDurr /= 2;
                break;
            case 2:
                glowDelay /= 1.5;
                // animDurr /= 1.5;
                break;
            default:
                break;
        }
        
        // console.log(this.gameData!.countedWays);
        // console.log(this.gameData!.rawData.totalWays);

        for (let tb: number = 0; tb < 2; tb++) {
            const isTopBar:boolean = tb == 0;
            this.fsTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.FS_LINE_FIRE), delay);
            
            for (let r: number = 0; r < SanEngineManager.AllReels.length; r++) {
                if (RevealerManager.getBotBar(r).isActive) {
                    this.fsTimeline.add(() => ScatterRevealPresentation.flashBarOnce(r, isTopBar), delay);
                    delay += glowDelay;
                }
            }
            delay += 0.4;
            for (let r: number = 0; r < SanEngineManager.AllReels.length; r++) {

                if(!RevealerManager.getBotBar(r).isActive) continue;
                if(!this.firstFs && !SanEngineManager.isQuickStop) this.fsTimeline.add(() => ScatterRevealPresentation.flashBarFS(r, isTopBar), delay);
                if(!this.firstFs) this.fsTimeline.add(() => ScatterRevealPresentation.revealBarFS(r, isTopBar), delay);// + animDurr / 2);

                const animDD:number = delay + animDurr/2;
                const indXway:number = tb*5 + r;

                if(!this.firstFs) this.fsTimeline.add(() => XWaysCounter.instance.setValue(undefined,this.gameData!.countedWays[indXway],0.25), animDD);// + animDurr / 2);

                if(!isTopBar && RevealerManager.getBotBar(r).state.equal(ReavealerState.EXPANDING) && RevealerManager.getTopBar(r).state.equal(ReavealerState.EXPANDING)){
                    SanEngineManager.AllReels[r].doubleExpand = true;
                    this.fsTimeline.add(() => ScatterRevealPresentation.revealTwoMyst(r),animDD);
                    this.fsTimeline.add(() => RevealerManager.getTopBar(r).specialBarStop(0,true),animDD);
                    
                    this.fsTimeline.to(this,1.5,{},animDD)
                    if(SanEngineManager.isQuickStop) this.quickStopExpanding = true;
                }else if(!isTopBar && RevealerManager.getBotBar(r).state.equal(ReavealerState.EXPANDING)){
                    this.fsTimeline.add(() => RevealerManager.getBotBar(r).specialBarLand(1),animDD-0.1);
                }
                else if(isTopBar &&  RevealerManager.getTopBar(r).state.equal(ReavealerState.EXPANDING)){
                    this.fsTimeline.add(() => RevealerManager.getTopBar(r).specialBarLand(1),animDD-0.1);
                }

                let playWildUpgradeSound:boolean = false;

                if(isTopBar &&  RevealerManager.getTopBar(r).state.equal(ReavealerState.MULTIPLIER)){
                    RevealerManager.getBotBar(r).state.equal(ReavealerState.MULTIPLIER)
                    for(let jw:number = 0; jw < JumpingWildController.instance.items.length;jw++){
                        if(JumpingWildController.instance.items[jw].ReelID == r){
                            playWildUpgradeSound = true;
                            const val:number = RevealerManager.getBotBar(r).state.equal(ReavealerState.MULTIPLIER) ? this.jumpData[jw].to.multiplier!/2 : this.jumpData[jw].to.multiplier!; 
                            this.fsTimeline.add([
                                () => JumpingWildController.instance.changeMult(jw,val),
                            ] ,animDD);
                            multUpgrade = RevealerManager.getBotBar(r).state.equal(ReavealerState.MULTIPLIER) ? 2 : 1;
                        }
                    }
                    this.fsTimeline.add(() => [
                        ReelAnimationManager.getReelArea(r).playPlusScatter(1),
                        RevealerManager.getTopBar(r).specialBarLand()
                    ] ,animDD-0.1);
                }

                if(!isTopBar && RevealerManager.getBotBar(r).state.equal(ReavealerState.MULTIPLIER)){
                    for(let jw:number = 0; jw < JumpingWildController.instance.items.length;jw++){
                        if(JumpingWildController.instance.items[jw].ReelID == r){
                            playWildUpgradeSound = true;
                            this.fsTimeline.add([
                                () => JumpingWildController.instance.changeMult(jw,this.jumpData[jw].to.multiplier!)
                            ],animDD);
                            multUpgrade = !multUpgrade ? 1 :  multUpgrade;
                        }
                    }

                    this.fsTimeline.add(() => [
                        ReelAnimationManager.getReelArea(r).playPlusScatter(RevealerManager.getTopBar(r).state.equal(ReavealerState.MULTIPLIER) ? 2 : 1),
                        RevealerManager.getBotBar(r).specialBarLand()
                    ] ,animDD-0.1);
                }

                if(playWildUpgradeSound){
                    this.fsTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.WILD_UPGRADE),delay);
                }
                delay += animDurr/(GameSetting.isFastSpin ? 4 : 2);

            }
            delay += GameSetting.isFastSpin ? 0 : 0.1;
        }

        this.fsTimeline.to(this, 0.2 + Math.max(multUpgrade,expandDurr), {});
        this.stopFlow.set(StopFlowState.BONUS_STOP, true)
        
        this.pTimeline.to(this,(this.fsTimeline.duration() - this.fsTimeline.time()),{});
    }

    private fetchJumpOffsetDelay():number{
        let jumpDelay:number = 0;
        for (let j: number = 0; j < JumpingWildController.instance.items.length; j++) {
            jumpDelay += JumpingWildController.instance.jumpDelay(j);
        }
        return jumpDelay;
    }

    protected BonusJump(): void {
        this.debugLogs && console.log("BonusJump")

        if (this.stopFlow.equal(StopFlowState.BONUS_BARS, true)) {
            if(this.fsTimeline && this.fsTimeline.isActive()) this.pTimeline.to(this,this.fsTimeline.duration() - this.fsTimeline.time(),{});
            else{
                const jumpDelay:number = this.fetchJumpOffsetDelay();
                if(jumpDelay > 0) this.pTimeline.to(this,jumpDelay,{});
                else this.stopFlow.set(StopFlowState.BONUS_BARS)
            }
            return;
        }

        this.fsTimeline = Helper.timeLineKiller(this.fsTimeline,
            new TimelineMax({ onComplete: () => {
                if(this.fetchJumpOffsetDelay() > 0) return;
                this.stopFlow.set(StopFlowState.BONUS_BARS);
            }})
        );

        let playSound:boolean = false;
        const jumpDurr:number = 0.5;
        for (let j: number = 0; j < JumpingWildController.instance.items.length; j++) {
            if(JumpingWildController.instance.items[j].multValue > 1) playSound = true;
        }
        if(JumpingWildCollector.instance.showing){
            JumpingWildCollector.instance.popToPos(this.jumpData);
            this.fsTimeline.add(JumpingWildCollector.instance.popJumpingWilds());
            if(playSound)
                this.fsTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.FS_MULT_TURN),0.5);
        }
        else{
            for (let j: number = 0; j < JumpingWildController.instance.items.length; j++) {
                this.fsTimeline.add(() => JumpingWildController.instance.JumpTo({ ID: j, to: this.jumpData[j].to, mult:this.jumpData[j].from.multiplier, duration: jumpDurr }),0);
                this.fsTimeline.to(this,jumpDurr,0);
                if(JumpingWildController.instance.items[j].multValue > 1) playSound = true;
            }
            if(playSound)
            this.fsTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.FS_MULT_TURN),0.7);
            
        }

        this.fsTimeline.to(this, GameSetting.isFastSpin ? 0.1 : 0.2, {});
        this.stopFlow.set(StopFlowState.BONUS_BARS, true);

        this.pTimeline.delay((this.fsTimeline.duration() - this.fsTimeline.time()));

    }

    protected BonusStop(): void {
        this.debugLogs && console.log("BonusStop")

        if (this.stopFlow.equal(StopFlowState.NORMAL, true)) {
            this.pTimeline.delay((this.fsTimeline.duration() - this.fsTimeline.time()));
            return;
        }

        this.fsTimeline = Helper.timeLineKiller(this.fsTimeline,
            new TimelineMax({ onComplete: () => this.stopFlow.set(StopFlowState.NORMAL) })
        );

        if(this.firstFs){
            
            for(let i:number = 0; i < SanEngineManager.AllReels.length;i++){
                if(SanEngineManager.AllReels[i].isActive && !SanEngineManager.AllReels[i].isLockedReel) { this.startDarkAttention = i; break; }
            }

            if(this.startDarkAttention != -1)
                ReelAnimationManager.getReelArea(this.startDarkAttention).graphFlash(true);
                
            RevealerManager.getAllBars().forEach(b => b.attentionDarkness(0.7,0.2))

            SanEngineManager.AllReels.forEach((r) => {
                r.setAttentionSym("S");
                if(r.isLockedReel) r.changeAlpha(0.35,0.25);
                else if(!r.isActive) r.changeAlpha(0, 0.25);
            });
        }else{
            XWaysCounter.instance.setValue(undefined,this.gameData!.rawData.totalWays,0.25);
            SanEngineManager.AllReels.forEach((r) => r.changeAlpha(0.35,0.25) );
        }

        this.fsTimeline.to(this, this.firstFs ? 0.6 :  0.15 + (this.quickStopExpanding ? 3 : 0), {});
        this.stopFlow.set(StopFlowState.NORMAL, true);

        this.quickStopExpanding = false;
        this.pTimeline.to(this,(this.fsTimeline.duration() - this.fsTimeline.time()),{},0);
    }

    protected calculateStopDelays(): number[] {
        let delay: number = 0.01;

        const delays: number[] = [];
        const timeRes: number[] = ArrayHelper.initArrayWithValues(SanEngineManager.AllReels.length, (i: number) => SanEngineManager.getReel(i).getNextAnimationTime());

        for (let reel = 0; reel < SanEngineManager.AllReels.length; reel++) {
            const rc: ReelEngineController = SanEngineManager.getReel(reel);

            if (!rc.isActive || rc.state.isIdle) {
                delays.push(0);
                continue;
            }

            if(this.stupidBuyFlag){
                delay += 0.1;
            } else{
                delay += GameSetting.isFastSpin || SanEngineManager.isQuickStop ?  timeRes[reel]*0.4 :  timeRes[reel]*0.4;
                delay = SanEngineManager.isQuickStop ? Math.max(0, delay - timeRes[reel]*0.9) : delay;
            }

            delays.push(delay);
        }

        return delays;
    }

    protected normalStop(delays: number[] = this.calculateStopDelays()): void {
        if(this.bigWinLvl){
            delays = this.bigDelayModifier(delays);
        }
        else 
        if(!this.stupidBuyFlag){
            delays = this.playFsAnimations ? this.FSModifier(delays) : this.normalDelayModifier(delays);
        }

        this.pTimeline.add(() => { }, SanEngineManager.stopReels(delays));
    }

    private normalDelayModifier(delays: number[]): number[] {
        let delay: number = 0;
        let delayAttentionCounter: number = -1;
        const startDurr: number = GameSetting.isFastSpin ? 0.35 : 0.5;

        if (SanEngineManager.isQuickStop) return delays;
        for (let reel = 0; reel < SanEngineManager.AllReels.length; reel++) {
            if (delays[reel] == 0) continue;
            delays[reel] += delay;

            if (!SanEngineManager.getReel(reel).isActive || SanEngineManager.getReel(reel).state.isIdle) {
                continue;
            }

            const winLine:boolean = this.gameData!.allWinData.longest !== 0 || this.gameData!.allWinData.longest > reel;

            if (winLine || reel < 2) {
                if((this.gameData!.wildReelPositions![reel].length > 0))
                    delay += SanEngineManager.isQuickStop ? 0 : GameSetting.isFastSpin ? 0.4 : 0.8;
                else
                    delay += SanEngineManager.isQuickStop || GameSetting.isFastSpin ? 0 : 0.15;
            }else if((this.gameData!.wildReelPositions![reel].length > 0)){
                delay += SanEngineManager.isQuickStop ? 0 : GameSetting.isFastSpin ? 0.25 : 0.4;
            }

            if (this.gameData!.scatterReelPositions![reel] >= 0 || delayAttentionCounter >= 0) {
                if (this.gameData!.scatterReelPositions![reel] >= 0) delayAttentionCounter++;

                if(reel > 2 && delayAttentionCounter == 0 && (!winLine || reel < 2)){
                    delay += 0.1;
                    continue;
                } 

                delayAttentionCounter = Math.min(delayAttentionCounter, 1);
                delay += startDurr + delayAttentionCounter * 1.4;
            }

        }
        return delays;
    }

    private bigDelayModifier(delays: number[]): number[] {
        const nervDelay: number = 1.8;
        let delay: number = 0;
        for (let reel = 0; reel < SanEngineManager.AllReels.length; reel++) {
            if (delays[reel] == 0 || !SanEngineManager.getReel(reel).visible) continue;

            const winLine:boolean = this.gameData!.allWinData.longest !== 0 || this.gameData!.allWinData.longest > reel;

            if (this.longestWin <= reel && reel >= 3) delay += nervDelay;

            else if (winLine || reel < 2) {
                if((this.gameData!.wildReelPositions![reel].length > 0))
                    delay += SanEngineManager.isQuickStop ? 0 : 0.8;
                else
                    delay += SanEngineManager.isQuickStop || GameSetting.isFastSpin ? 0 : 0.15;
            }else if((this.gameData!.wildReelPositions![reel].length > 0)){
                delay += SanEngineManager.isQuickStop ? 0 : 0.4;
            }

            delays[reel] += delay;
        }

        return delays;
    }

    private FSModifier(delays: number[]): number[] {
        const firstDelay:number = GameSetting.isFastSpin ? 0.5 : 2;
        let standardDel: number = GameSetting.isFastSpin ? 0.45 : 0.75;
        standardDel = SanEngineManager.isQuickStop ? 0 : standardDel;
        let delay: number = 0;

        if(SanEngineManager.isQuickStop) return delays;

        if(this.firstFs){
            for (let reel = 0; reel < SanEngineManager.AllReels.length; reel++) {
                if (delays[reel] == 0 || !SanEngineManager.getReel(reel).visible) continue;
                if(this.gameData!.rawData.topRowOpened[reel]){
                    delays[reel] += delay;
                    delay += firstDelay;
                }
            }
        }
        else{
            for (let reel = 0; reel < SanEngineManager.AllReels.length; reel++) {
                if (delays[reel] == 0 || !SanEngineManager.getReel(reel).visible) continue;
                delays[reel] += delay;
                if (this.gameData!.allWinData.longest > reel || reel < 2) {
                    delay += standardDel;
                }else{
                    delay += standardDel/2;
                }

                if (this.gameData!.scatterReelPositions![reel] >= 0 && this.gameData!.scatterReelPositions![reel] <= 2) {
                    delay += 0.8;
                }
            }

        }
        return delays;
    }

    private bigWinBehave(reelID:number){
        if(reelID >= 2 && this.bigWinLvl && !SanEngineManager.isQuickStop){
            if(this.gameData!.allWinData.longest >= reelID){
            if(reelID+1 < SanEngineManager.AllReels.length) ReelAnimationManager.getReelArea(reelID+1).graphFlash(true, 0.55);
                if(this.gameData!.allWinData.longest > reelID){
                    if(!this.bigWinLandsound && reelID == 3){
                        SoundManager.playSoundEffect(SoundConfig.instance.BIG_WIN_ATTENTION);
                        SanBackground.instance.playAttentionBlackFlash(1,0.5,0.35);
                        this.bigWinLandsound = true;
                    }

                    AnimationEffects.Shake({
                        obj:StageManager.stage,
                        duration: 1.2,
                        hertz:120,
                        x:0.6,
                        y:0.8,
                        Intensity: reelID == 2 ? 4 : reelID === 3 ? 6 : 8,
                        positionCb: () => new PIXI.Point(0,0),
                        ease: Power3.easeOut,
                        reverseEase:true
                    });
                }
            }
        }
    }

    protected playBounceAnimation(reelID: number): void {
        if (this.gameData == undefined || !SanEngineManager.getReel(reelID).isActive) return;

        SanEngineManager.getReel(reelID).changeAlpha(0, SanEngineManager.getReel(reelID).getStopDuration() / 2);
        ReelAnimationManager.getReelArea(reelID).graphFlash(false);
        if(this.gameData!.mode === GameMode.FREESPIN)
            ReelAnimationManager.getReelArea(reelID).stopPlusScatter();

        this.nearWinBehaviour(reelID);
        this.scatterLand(reelID);
        this.wildLand(reelID);
        this.bigWinBehave(reelID);

        // stopFsLand
        if(this.firstFs)
            this.attentionReels(reelID);
        else
            SoundManager.playSoundEffect(SoundConfig.instance.REELS_DEFAULT_BOUNCE[0]);

        if(!(this.gameData!.scatterReelPositions![reelID] > 0 || this.gameData!.wildReelPositions![reelID].length > 0))
            TweenLite.to(this,SanEngineManager.isQuickStop ? 0.01 : 0.05,{}).eventCallback("onComplete", () =>  AnimationEffects.Shake({
                obj:SanEngineManager.getReel(reelID),
                duration: 0.3,
                hertz: 75 ,
                x:0.08,
                y:0.7,
                positionCb: () => SanEngineManager.getReel(reelID).calcedPos,
                Intensity: 5,
                ease: Power3.easeOut,
                reverseEase:true
            }));

        if (reelID == SanEngineManager.LastStopReel){
            SoundManager.stopSoundEffect(SoundConfig.instance.REELS_SPINNING,200);
            if(this.haveSkyDarkenned){
                this.haveSkyDarkenned = false;
                SoundManager.stopSoundEffect(SoundConfig.instance.SCATTER_ATTENTION,500);
                if(!this.nextIsFS && this.gameData.mode === GameMode.NORMAL){
                    SoundManager.playSoundEffect(SoundConfig.instance.SCATTER_ATTENTION_MISS);
                    JumpingWildCollector.instance.reset();
                } 
            }
            if(this.bigWinLandsound) {
                SoundManager.stopSoundEffect(SoundConfig.instance.BIG_WIN_ATTENTION);
                SoundManager.playSoundEffect(SoundConfig.instance.BIG_WIN_ATTENTION_DOOR)
            }
        }
        
    }

    private wildLand(reelID: number): void {

        if (this.gameData!.wildReelPositions![reelID].length > 0){

            if(this.gameData?.mode == GameMode.NORMAL){
                const SEN: SanEngineController = SanEngineManager.getReel(reelID);
                const symIdPos: number = this.gameData!.wildReelPositions![reelID][0];
                const wildPos = this.gameData!.wildReelPositions![reelID][0];
                const delay: number = SEN.getSymbol(symIdPos)!.changeState({ state: SanSymState.LANDING, newSym:"W_S"})!.duration();
                const lstTime: number = this.wildTimeline.totalTime() + delay*1.25;


                this.wildTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.WILD_SPLIT), lstTime);
                if (wildPos == 0) {
                    this.wildTimeline.add(SEN.getSymbol(1)?.changeState({ state: SanSymState.SPLIT }), lstTime)
                    this.wildTimeline.add(SEN.getSymbol(2)?.changeState({ state: SanSymState.SPLIT }), lstTime)
                }
                else if (wildPos == 1) {
                    this.wildTimeline.add(SEN.getSymbol(0)?.changeState({ state: SanSymState.SPLIT }), lstTime)
                    this.wildTimeline.add(SEN.getSymbol(2)?.changeState({ state: SanSymState.SPLIT }), lstTime)
                } else {
                    this.wildTimeline.add(SEN.getSymbol(1)?.changeState({ state: SanSymState.SPLIT }), lstTime)
                    this.wildTimeline.add(SEN.getSymbol(0)?.changeState({ state: SanSymState.SPLIT }), lstTime)
                }

                if (wildPos == 0) {
                    SEN.getSymbol(1)?.dirrAtt(true, undefined, 2);
                    SEN.getSymbol(2)?.dirrAtt(true, undefined, 2);
                }
                else if (wildPos == 1) {
                    SEN.getSymbol(0)?.dirrAtt(true, true, 2);
                    SEN.getSymbol(2)?.dirrAtt(true, undefined, 2);
                } else {
                    SEN.getSymbol(0)?.dirrAtt(true, true, 2);
                    SEN.getSymbol(1)?.dirrAtt(true, true, 2);
                }

                SoundManager.playSoundEffect(SoundConfig.instance.WILD_LAND);
                AnimationEffects.Shake({
                    obj:SEN,
                    duration:0.6,
                    hertz:75,
                    x:0.15,
                    y:0.8,
                    Intensity:6,
                    positionCb: () => SanEngineManager.getReel(reelID).calcedPos,
                    ease: Power3.easeOut,
                    reverseEase:true
                });
            }
        }
    }

    private scatterLand(reelID: number): void {
        if (this.gameData!.scatterReelPositions![reelID] >= 0 && !this.firstFs) {
            const SEN: SanEngineController = SanEngineManager.getReel(reelID);
            const scattPos = this.gameData!.scatterReelPositions![reelID];

            let ammLandedScatters:number = 0;
            for(let r:number = 0; r < reelID+1;r++){
                if(!SanEngineManager.AllReels[r].isActive) continue;
                if(this.gameData!.scatterReelPositions![r] >= 0) ammLandedScatters++;
            }

            if(this.gameData?.mode === GameMode.FREESPIN){
                SoundManager.playSoundEffect(SoundConfig.instance.FS_SCATTER_LAND)
            }else{
                SoundManager.playSoundEffect(SoundConfig.instance.SCATTER_LAND[Math.min(ammLandedScatters-1,4)])
                JumpingWildCollector.instance.indicatorState(ammLandedScatters);
            }
            
            RevealerManager.getTopBar(reelID).openBar();
            RevealerManager.getBotBar(reelID).openBar();
            SoundManager.playSoundEffect(SoundConfig.instance.BAR_OPEN);
            
            if (scattPos == 0) {
                SEN.getSymbol(1)?.dirrAtt(true);
                SEN.getSymbol(2)?.dirrAtt(true);
            }
            else if (scattPos == 1) {
                SEN.getSymbol(0)?.dirrAtt(true, true);
                SEN.getSymbol(2)?.dirrAtt(true);
            } else {
                SEN.getSymbol(0)?.dirrAtt(true, true);
                SEN.getSymbol(1)?.dirrAtt(true, true);
            }

            if (reelID == this.startDarkAttention) {
                SoundManager.playSoundEffect(SoundConfig.instance.SCATTER_ATTENTION);
                
                for (let s: number = 0; s <= reelID; s++) {
                    if (this.gameData!.scatterReelPositions![s] >= 0) {
                        const sID: number = this.gameData!.scatterReelPositions![s] + SanEngineManager.getReel(s).stepPosOffset;
                        SanEngineManager.getReel(s).getSymbol(sID)?.changeState({ state: ReelSymbolStates.ATTENTION });
                    }
                }
                for (let reel: number = reelID+1; reel < SanEngineManager.AllReels.length; reel++){
                    SanEngineManager.getReel(reel).setAttentionSym("S");
                }
                SanBackground.instance.playAttentionBlackFlash(1, 0.5, 0.4);
                SanBackground.instance.changeSkyToBlack(0.48);
                this.haveSkyDarkenned = true;

            } else if (this.playFsAnimations || (reelID > this.startDarkAttention && this.startDarkAttention != -1)) {
        
                SanEngineManager.getReel(reelID).getSymbol(scattPos)?.changeState({ state: ReelSymbolStates.ATTENTION });

                AnimationEffects.Shake({
                    obj:StageManager.stage,
                    duration: 0.5,
                    hertz:120,
                    x:0.6,
                    y:0.8,
                    Intensity:2,
                    positionCb: () => new PIXI.Point(0,0),
                    ease: Power3.easeOut,
                    reverseEase:true
                })

                if(this.gameData?.mode == GameMode.NORMAL)
                    SanBackground.instance.changeSkyToBlack(0.85);
                else{
                    RevealerManager.getTopBar(reelID).attentionDarkness(0);
                    RevealerManager.getBotBar(reelID).attentionDarkness(0);

                    RevealerManager.getTopBar(reelID).setSpinMode(false);
                    RevealerManager.getBotBar(reelID).setSpinMode(false);
                }

            }
            AnimationEffects.Shake({
                obj:SEN,
                duration:0.6,
                hertz:75,
                x:0.15,
                y:0.8,
                Intensity:6,
                positionCb: () => SanEngineManager.getReel(reelID).calcedPos,
                ease: Power3.easeOut,
                reverseEase:true
            });
        } else if (reelID <= 4 && !RevealerManager.getBotBar(reelID).isActive) {
            RevealerManager.getTopBar(reelID).shuffle(false);
            RevealerManager.getBotBar(reelID).shuffle(false);
        }
    }

    private flashNextReel(reelID:number):void{
        for(let r:number = reelID+1; r < SanEngineManager.AllReels.length;r++){
            if(this.gameData!.rawData.topRowOpened[r]){
                ReelAnimationManager.getReelArea(r).graphFlash(true);
                break;
            }
        }
    }

    private nearWinBehaviour(reelID: number): void {
        if (!(this.gameData!.mode == GameMode.FREESPIN || this.gameData!.mode == GameMode.NORMAL)) return;
        // if (this.gameData!.mode != GameMode.NORMAL)return;

        if(this.gameData?.singleWin == 0) return;

        const isFS:boolean = this.gameData?.mode == GameMode.FREESPIN;

        const darkIntensity: number = isFS ? 0.6 : 0.3;
        const stopdurr:number = SanEngineManager.getReel(reelID).getStopDuration();
        if (SanEngineManager.isQuickStop) {
            for (let reel: number = 0; reel <= reelID; reel++) {
                for (let j: number = 0; j < SanEngineManager.getReel(reel).windowAmount; j++) {
                    let symPos: number = SanEngineManager.getReel(reel).AllWindowSymbols[j].posID;
                    SanEngineManager.getReel(reel).getSymbol(symPos)!.attentionDarkness(0, stopdurr);
                }
            }
            return;
        } else if (this.nearWinLength > 2 && reelID >= 2) {
            // Backward connection
            if (reelID == 2) {
                for (let i: number = 0; i < this.possibleWinSymbols[reelID].length; i++) {
                    for (let reel: number = reelID; reel >= 0; reel--) {
                        const reelC: SanEngineController = SanEngineManager.getReel(reel);
                        for (let row: number = 0; row < reelC.windowAmount; row++) {
                            let symPos: number = reelC.AllWindowSymbols[row].posID;
                            if(isFS){
                                let ignoreDueToJW:boolean = false;
                                for(let jw:number = 0; jw < this.jumpData.length;jw++){
                                    if(this.jumpData[jw].to.reel == reel && this.jumpData[jw].to.row == symPos){
                                        ignoreDueToJW = true;
                                    }
                                }
                                if(ignoreDueToJW) continue;
                            }
                            const symbol: SanSpriteSymbol = reelC.getSymbol(symPos)!;
                            const symbolHit: boolean = this.possibleWinSymbols[reelID].indexOf(symbol.symName) >= 0;

                            if (!symbolHit) symbol.attentionDarkness(darkIntensity, stopdurr);
                        }
                        if(isFS && this.gameData?.rawData.topRowOpened[reel]){
                            for (let tb = 0; tb < 2; tb++) {
                                const symbolName: string = tb == 0 ? this.gameData?.fsMergedreel[reel][0] : this.gameData?.fsMergedreel[reel][4];
                                const symbolHit: boolean = this.possibleWinSymbols[reelID].indexOf(symbolName) >= 0;
                                if (!symbolHit && symbolName != "W"){
                                    const bar: Revealer = tb == 0 ? RevealerManager.getTopBar(reel) : RevealerManager.getBotBar(reel);
                                    if(!bar.state.equal(ReavealerState.EXPANDING) && !bar.state.equal(ReavealerState.MULTIPLIER))
                                        bar.attentionDarkness(darkIntensity,stopdurr)
                                }
                            }
                        }
                    }
                }
            }
            else if (this.possibleWinSymbols[reelID] != undefined) { // Current connection
                this.setNonWinSymbolsOnReel(reelID,isFS);
            } else {
                for (let j: number = 0; j < SanEngineManager.getReel(reelID).windowAmount; j++) {
                    let symPos: number = SanEngineManager.getReel(reelID).AllWindowSymbols[j].posID;
                    const symbol: SanSpriteSymbol = SanEngineManager.getReel(reelID).getSymbol(symPos)!;
                    symbol.attentionDarkness(darkIntensity, stopdurr);
                }
                if(isFS && this.gameData?.rawData.topRowOpened[reelID]){
                    for (let tb = 0; tb < 2; tb++) {
                        const symbolName: string = tb == 0 ? this.gameData?.fsMergedreel[reelID][0] : this.gameData?.fsMergedreel[reelID][4];
                        const bar: Revealer = tb == 0 ? RevealerManager.getTopBar(reelID) : RevealerManager.getBotBar(reelID);
                        if(!bar.state.equal(ReavealerState.EXPANDING) && !bar.state.equal(ReavealerState.MULTIPLIER) && symbolName != "W")
                            bar.attentionDarkness(darkIntensity,stopdurr)
                    }
                }
            }
        }
    }

    private setNonWinSymbolsOnReel(targetReel:number,isFs:boolean):void{
        const darkIntensity: number =  isFs ? 0.6 : 0.3;
        const stopdurr:number = SanEngineManager.getReel(targetReel).getStopDuration();

        const reelC: SanEngineController = SanEngineManager.getReel(targetReel);
        for (let row: number = 0; row < reelC.windowAmount; row++) {
            let symPos: number = reelC.AllWindowSymbols[row].posID;
            if(isFs){
                let ignoreDueToJW:boolean = false;
                for(let jw:number = 0; jw < this.jumpData.length;jw++){
                    if(this.jumpData[jw].to.reel == targetReel && this.jumpData[jw].to.row == symPos){
                        ignoreDueToJW = true;
                    }
                }

                if(ignoreDueToJW) continue;
            }

            const symbol: SanSpriteSymbol = reelC.getSymbol(symPos)!;
            const symbolHit: boolean = this.possibleWinSymbols[targetReel].indexOf(symbol.symName) >= 0;
            if (!symbolHit) symbol.attentionDarkness(darkIntensity, stopdurr);
        }
        if(isFs && this.gameData?.rawData.topRowOpened[targetReel]){
            for (let tb = 0; tb < 2; tb++) {
                const symbolName: string = tb == 0 ? this.gameData?.fsMergedreel[targetReel][0] : this.gameData?.fsMergedreel[targetReel][4];
                const symbolHit: boolean = this.possibleWinSymbols[targetReel].indexOf(symbolName) >= 0;
                if (!symbolHit && symbolName != "W"){
                    const bar: Revealer = tb == 0 ? RevealerManager.getTopBar(targetReel) : RevealerManager.getBotBar(targetReel);
                    if(!bar.state.equal(ReavealerState.EXPANDING) && !bar.state.equal(ReavealerState.MULTIPLIER))
                        bar.attentionDarkness(darkIntensity,stopdurr)
                }
            }
        }
    }

    protected playStopAnimation(reelID: number): void {
        if (this.gameData == undefined || !SanEngineManager.getReel(reelID).isActive) return;

        if(this.firstFs){
            SoundManager.playSoundEffect(SoundConfig.instance.REELS_DEFAULT_BOUNCE[0]);
            SoundManager.playSoundEffect(SoundConfig.instance.BAR_LANDING_BOUNCE);
            let countMyst:number = 0;
            for(let r = 0; r <= reelID;r++){
                if(SanEngineManager.getReel(r).isActive)
                    countMyst += this.gameData!.mystReelPositions![r].length;
            }

            let playCollectSound:boolean = false;

            for(let zIn:number = 0; zIn < SanEngineManager.getReel(reelID).AllWindowSymbols.length; zIn++){
                if(SanEngineManager.getReel(reelID).AllWindowSymbols[zIn].symName === "Z") {
                    (<SanSpriteSymbol> SanEngineManager.getReel(reelID).AllWindowSymbols[zIn]).glowFirstFs(0.3,2);
                    playCollectSound = true;
                };
            }

            if(playCollectSound)
                SoundManager.playSoundEffect(SoundConfig.instance.FS_MULTIPLIER_COLLECT);

            SplashViewJWWon.changeValue(countMyst)
        }
     
        if (this.playFsAnimations) {

            const isOpen:boolean = RevealerManager.getBotBar(reelID).isActive;
            const topbarExp:boolean = RevealerManager.getTopBar(reelID).state.equal(ReavealerState.EXPANDING);
            const bottbarExp:boolean = RevealerManager.getBotBar(reelID).state.equal(ReavealerState.EXPANDING);

            let mergeStartDelay:number = this.fsTimeline.totalTime();
            if(this.jumpData.length > 0){
                for (let j: number = 0; j < JumpingWildController.instance.items.length; j++) {
                    if (this.jumpData[j].to.reel == reelID){
                        JumpingWildController.instance.MergeWithReel(j,true, (isOpen && (topbarExp || bottbarExp)));
                        mergeStartDelay += 0.15;
                    }
                }
            }

            if (this.gameData.scatterReelPositions[reelID] === -1 && isOpen){
                if(!(bottbarExp && topbarExp))
                this.fsTimeline.add(ScatterRevealPresentation.barPresentation(reelID, true), mergeStartDelay);
                this.fsTimeline.to(this,0.2,{},mergeStartDelay);
            }
        }

        if(!this.firstFs)
            this.attentionReels(reelID);

        if (reelID == SanEngineManager.LastStopReel)
            this.PresentationState.set(PresentationState.INACTIVE);
    }

    private attentionReels(reelID:number):void{

        if (this.startDarkAttention != -1) {

            if (reelID + 1 != 5 && this.startDarkAttention <= reelID){
                if(this.firstFs){
                    const rID:number = reelID;
                    const lstTime:number = this.fsTimeline.totalTime();
                    this.fsTimeline.to(this,1,{},lstTime);
                    TweenLite.to(this,1,{}).eventCallback("onComplete",() =>{
                        ReelAnimationManager.getReelArea(rID).graphFlash(false);
                        if(SanEngineManager.findFirstReelWithState(ReelState.STEP) == -1 && SanEngineManager.getStoppingReel() == -1) return;
                        if(!SanEngineManager.isQuickStop && !this.stupidBuyFlag) this.flashNextReel(rID);
                    })
                }
                else{
                    if(!SanEngineManager.isQuickStop)
                        ReelAnimationManager.getReelArea(reelID + 1).graphFlash(true);
                } 
            }
            if(!this.firstFs && reelID > this.startDarkAttention && this.gameData?.scatterReelPositions[reelID]! >= 0 && this.gameData?.scatterReelPositions[reelID]! <= 2){
                let count:number = -JumpingWildController.instance.items.length;
                let findReelWild:number = 0;

                for(let r:number = 0; r < SanEngineManager.AllReels.length; r++){
                    if(this.gameData?.scatterReelPositions[r]! >= 0) count++;
                    else continue;

                    if(count == 1) findReelWild = r;

                    if(count == 3){
                        SoundManager.playSoundEffect(SoundConfig.instance.WILD_EXPLODE);
                        JumpingWildCollector.instance.setActiveJumpingWilds(JumpingWildController.instance.items.length,  findReelWild, this.gameData!.scatterReelPositions![findReelWild])
                        break;
                    }
                }
            }
        }
    }

    // Checks if any reels are still stopping.
    public promiseSync(): boolean {
        const notFinished: boolean = !(SanEngineManager.getStoppingReel() >= 0 || SanEngineManager.findFirstReelWithState(ReelState.STEP) >= 0)
        if(!notFinished) return notFinished;
        if (this.playFsAnimations) {
            if (this.fsTimeline && this.fsTimeline.isActive()) {
                if(!this.gameData?.singleWin) this.fsTimeline.timeScale(1.5);
                return false;
            }
        }

        if (this.wildTimeline && this.wildTimeline.isActive()){
            return false;
        } 
        return notFinished;
    }

    public stopPresentation(): void {

        SanEngineManager.RAll((r:number) => {
            if(!this.nextIsFS && this.gameData?.mode === GameMode.NORMAL) SanEngineManager.getReel(r).setAttentionSym("");
            // else SanEngineManager.getReel(r).setAttentionSym("S");
            SanEngineManager.getReel(r).updateParsedData();
            SanEngineManager.getReel(r).doubleExpand = false;
            // if(this.gameData?.mode === GameMode.FREESPIN){
            //     SanEngineManager.getReel(r).doubleExpand = false;
            // }
            ReelAnimationManager.getReelArea(r).stopPlusScatter(true);
            ReelAnimationManager.getReelArea(r).graphFlash(false);
        });
        
        SanEngineManager.isPlaying = false;
        if(this.gameData!.freespinsLeft) PostCounter.instance.setAmount(this.gameData!.freespinsLeft);

        this.fsTimeline && this.fsTimeline.timeScale(1);
        Logger.logDev(TimeCheckPoints.getCheckPointTime("Bet").toString());
        this.gameData = undefined;
    }
}